import FormControl from "common/components/FormControl/FormControl";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CrudForm from "common/components/Crud/CrudForm";
import ProductSelect from "components/select/ProductSelect/ProductSelect";
import TagSelect from "components/select/TagSelect/TagSelect";
import type { Document } from "types";

type Props = {
  onSubmit: (values: any) => any;
  onCancel?: () => void;
  item?: Document;
};

function DocumentForm({ onSubmit, onCancel, item }: Props) {
  const { t } = useTranslation();

  const initialValues = useMemo(
    () =>
      item?.id
        ? {
            ...item,
            media: item.media ? [item.media] : [],
            products: item.products?.map((p) => p.id) || [],
            tags: item.tags?.map((tag) => tag.id) || [],
          }
        : {},
    [item],
  );

  return (
    <CrudForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
      headerIcon="DocumentTextIcon"
      i18nNamespace="documents"
      render={() => (
        <div className="flex flex-col gap-4 white-box">
          <FormControl
            name="media"
            title={t("documents.media")}
            type="file"
            max={1}
            required
            acceptImages
            acceptPdf
            acceptVideos
          />
          <FormControl
            name="products"
            title={t("documents.products")}
            type="custom"
            isSelect
          >
            <ProductSelect multiple />
          </FormControl>
          <FormControl
            name="tags"
            title={t("documents.tags")}
            type="custom"
            isSelect
          >
            <TagSelect multiple />
          </FormControl>
          <FormControl
            name="isSuggested"
            title={t("documents.isSuggested")}
            type="checkbox"
          />
        </div>
      )}
    />
  );
}

export default DocumentForm;
